import { render } from "./OfficeManagement.vue?vue&type=template&id=14481804"
import script from "./OfficeManagement.vue?vue&type=script&lang=js"
export * from "./OfficeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__